import { useEffect } from 'react'
import type { CSSProperties, DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react'
import './Modal.scss'

interface ModalProps extends PropsWithChildren<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> {
    open?: boolean
    contentProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
    className?: string
    style?: CSSProperties
}

export default function Modal({ children, open, className, contentProps, style, ...props }: ModalProps) {
    useEffect(() => {
        if (!open) return

        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'

        return () => {
            document.body.style.overflow = previousOverflow
        }
    }, [open])

    const contentClassName = [
        'modal-content',
        className,
        contentProps?.className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <div className="modal-overlay" style={{display: open ? 'flex' : ''}} {...props}>
            <div {...contentProps} className={contentClassName}>
                {children}
            </div>
        </div>
    )
}
